import { AxiosError } from 'axios';
import { logInfo } from 'utils/logging';
import { getCSRFTOKEN } from 'utils/cookie/getCSRFToken';
import { axiosAPI } from 'lib/api';

type UpdateQuestionResponse = {
  success: boolean;
  slug?: string;
};

const updateQuestion = async (
  questionSlug: string,
  body: string,
  category_id: number,
  grade: number,
): Promise<UpdateQuestionResponse> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN') || '';

  try {
    return await axiosAPI({
      url: `/otvety/api/questions/${questionSlug}`,
      method: 'PATCH',
      withCredentials: true,
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-TOKEN': csrf_token,
      },
      data: JSON.stringify({
        question: {
          body,
          category_id,
          grade,
        },
      }),
    });
  } catch (error) {
    const e = error as AxiosError;
    logInfo(e.toString(), true);
    return { success: false };
  }
};

export default updateQuestion;
